// React
import React, { useEffect, useState } from "react";

// Material UI
import {
  Box,
  Button,
  Stack,
  FormHelperText,
  CircularProgress,
} from "@mui/material";
import { ChevronRight, ChevronLeft, Save } from "@mui/icons-material";

// Libraries
import { DateTime } from "luxon";

// Styles
import { styles } from "./styles";
import { buttonStyles } from "Common/Styles";

const NavigationButtons = ({
  cancelClick,
  nextClick,
  backClick,
  saveClick,
  lastPageNumber,
  page,
  editAccount,
  loading,
}) => {
  const [atBottom, setAtBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } =
        document.documentElement;
      setAtBottom(scrollTop + clientHeight >= scrollHeight - 2); // 2px buffer
    };
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setAtBottom(false);
  }, [page]);

  return (
    <Stack direction="row" sx={styles.stickyFooter}>
      <Box sx={styles.buttonsBox}>
        <Stack direction="column" spacing={0} sx={{ alignItems: "flex-start" }}>
          {editAccount?.adminUpdate && (
            <FormHelperText>
              Last updated by: {editAccount.adminUpdate.updatedBy} on{" "}
              {DateTime.fromISO(editAccount.adminUpdate.updatedAt).toFormat(
                "MMMM dd, yyyy @hh:mm a"
              )}
            </FormHelperText>
          )}

          {!editAccount && (
            <Button
              type="button"
              variant="text"
              onClick={cancelClick}
              sx={buttonStyles.cancelButton}
            >
              Cancel Setup
            </Button>
          )}
        </Stack>
        <Stack direction="column" spacing={0} sx={{ alignItems: "flex-end" }}>
          <Stack direction="row" spacing={1}>
            {page !== 0 && !editAccount && (
              <Button
                type="button"
                variant="outlined"
                sx={styles.secondaryButton}
                onClick={backClick}
                startIcon={<ChevronLeft />}
              >
                Back
              </Button>
            )}
            {page !== lastPageNumber && !editAccount && (
              <Button
                type="button"
                variant="contained"
                sx={styles.mainButton}
                onClick={nextClick}
                endIcon={<ChevronRight />}
              >
                Next
              </Button>
            )}
            {(page === lastPageNumber || editAccount) && (
              <Button
                type="button"
                variant="contained"
                disabled={!(editAccount || atBottom) || loading}
                sx={styles.mainButton}
                onClick={saveClick}
                startIcon={
                  loading ? (
                    <CircularProgress size={20} sx={{ color: "white" }} />
                  ) : (
                    <Save />
                  )
                }
              >
                {loading ? <>Saving...</> : <>Save</>}
              </Button>
            )}
          </Stack>

          {!atBottom && page === lastPageNumber && !editAccount && (
            <FormHelperText>
              Scroll down to review the client’s information before finalizing
              setup.
            </FormHelperText>
          )}
        </Stack>
      </Box>
    </Stack>
  );
};

export default NavigationButtons;
